import axios from "axios";
// console.log(process.env["REACT_APP_API_URL" + window.ENV_POSTFIX]);
export default axios.create({
  baseURL:
    process.env["REACT_APP_API_URL" + window.ENV_POSTFIX] ||
    process.env.REACT_APP_API_URL,
  responseType: "json",
});
